import * as React from "react";
import { SVGProps } from "react";
const SvgInsurancePlan = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={24} height={24} rx={4} fill="#095921" />
    <path
      d="m16.623 17.676-3.546-3.546 1.36-1.36 3.547 3.546-1.36 1.36Zm-8.939 0-1.36-1.36 4.47-4.47-1.102-1.101-.453.453-.826-.825V11.7l-.453.454L6 10.194l.453-.453h1.328l-.81-.81 2.3-2.3c.216-.215.448-.372.697-.47a2.072 2.072 0 0 1 1.522 0c.248.098.48.255.696.47l-1.49 1.49.81.81-.453.454 1.1 1.1 1.458-1.457a2.684 2.684 0 0 1-.105-.372c-.027-.13-.04-.26-.04-.389 0-.637.218-1.174.656-1.611.437-.437.974-.656 1.61-.656.163 0 .317.016.463.049.145.032.293.08.445.145l-1.604 1.604 1.166 1.166 1.604-1.604c.075.151.127.3.154.445.027.146.04.3.04.462 0 .637-.218 1.174-.655 1.611-.438.438-.975.656-1.612.656-.13 0-.26-.01-.389-.032a1.49 1.49 0 0 1-.372-.113l-7.288 7.287Z"
      fill="#fff"
    />
  </svg>
);
export default SvgInsurancePlan;
